export default "__VITE_ASSET__CgNJ0BvO__"